import {useSelector} from "react-redux";

export const useInteractionCheck = () => {
    return useSelector(({generalState}) => generalState.canInteract);
}
